module.exports = __webpack_public_path__ + "static/assets/a933b8b20f7473854252589b22ed8319.png";